import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, FilterIcon, CalendarIcon, UserIcon, ClockIcon } from 'lucide-react';
const Insights = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activeCategory, setActiveCategory] = useState('all');
  const categories = [{
    id: 'all',
    label: 'All Topics'
  }, {
    id: 'ai',
    label: 'AI & Research'
  }, {
    id: 'sports',
    label: 'Sports & Entertainment'
  }, {
    id: 'urban',
    label: 'Urban Insights'
  }, {
    id: 'multicultural',
    label: 'Multicultural Research'
  }];
  const articles = [{
    id: 1,
    title: "AI in Consumer Research: Transforming How We Understand Toronto's Markets",
    category: 'ai',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1332&q=80',
    author: 'Dr. Sarah Chen',
    date: 'June 15, 2023',
    readTime: '8 min read',
    excerpt: "How artificial intelligence and machine learning are revolutionizing market research methodologies in Toronto's diverse consumer landscape."
  }, {
    id: 2,
    title: 'Sports Sponsorship Value Tracking: New Metrics for a Digital Age',
    category: 'sports',
    image: 'https://images.unsplash.com/photo-1459865264687-595d652de67e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    author: 'Michael Rodriguez',
    date: 'May 22, 2023',
    readTime: '6 min read',
    excerpt: "How Toronto's sports organizations are redefining sponsorship value in an increasingly digital and multichannel world."
  }, {
    id: 3,
    title: "Multicultural Urban Behavior Insights: Toronto's Changing Neighborhoods",
    category: 'multicultural',
    image: 'https://images.unsplash.com/photo-1518391846015-55a9cc003b25?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    author: 'Aisha Patel',
    date: 'April 10, 2023',
    readTime: '10 min read',
    excerpt: "Examining how cultural diversity shapes urban behaviors, preferences, and community development across Toronto's neighborhoods."
  }, {
    id: 4,
    title: "The Future of Smart Cities: Toronto's Data-Driven Urban Planning",
    category: 'urban',
    image: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1244&q=80',
    author: 'David Kim',
    date: 'March 5, 2023',
    readTime: '7 min read',
    excerpt: 'How Toronto is using research and data analytics to create smarter, more efficient urban environments.'
  }, {
    id: 5,
    title: "Cross-Cultural Research Methods: Lessons from Toronto's Diverse Communities",
    category: 'multicultural',
    image: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    author: 'Jean-Pierre Leblanc',
    date: 'February 18, 2023',
    readTime: '9 min read',
    excerpt: "Best practices for conducting effective research across Toronto's multicultural communities while avoiding bias and cultural misunderstandings."
  }, {
    id: 6,
    title: 'Generative AI and Market Research: Ethical Considerations',
    category: 'ai',
    image: 'https://images.unsplash.com/photo-1655720828018-edd2daec9349?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1332&q=80',
    author: 'Dr. Sarah Chen',
    date: 'January 30, 2023',
    readTime: '11 min read',
    excerpt: 'Examining the ethical implications of using generative AI in market research and how to ensure responsible implementation.'
  }];
  const filteredArticles = activeCategory === 'all' ? articles : articles.filter(article => article.category === activeCategory);
  const featuredArticle = articles[0];
  return <div className="pt-20" data-id="element-532">
      {/* Hero Section */}
      <section className="bg-neutral-light py-20" data-id="element-533">
        <div className="container mx-auto px-4 md:px-6" data-id="element-534">
          <div className="max-w-3xl mx-auto text-center" data-id="element-535">
            <motion.h1 initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="text-4xl md:text-5xl font-display font-bold mb-6" data-id="element-536">
              Insights <span className="text-toronto-blue" data-id="element-537">Hub</span>
            </motion.h1>
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="text-xl text-neutral-dark/80" data-id="element-538">
              The latest trends, thought leadership, and research insights from
              our team of experts.
            </motion.p>
          </div>
        </div>
      </section>
      {/* Featured Article */}
      <section className="py-12 bg-white" data-id="element-539">
        <div className="container mx-auto px-4 md:px-6" data-id="element-540">
          <h2 className="text-2xl font-display font-bold mb-6" data-id="element-541">
            Featured Article
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="grid grid-cols-1 lg:grid-cols-5 gap-8 bg-neutral-light/30 rounded-lg overflow-hidden" data-id="element-542">
            <div className="lg:col-span-2 h-64 lg:h-auto" data-id="element-543">
              <img src={featuredArticle.image} alt={featuredArticle.title} className="w-full h-full object-cover" data-id="element-544" />
            </div>
            <div className="lg:col-span-3 p-6 lg:p-8 flex flex-col justify-between" data-id="element-545">
              <div data-id="element-546">
                <div className="flex items-center mb-4" data-id="element-547">
                  <span className={`text-xs font-medium px-2 py-1 rounded-full ${featuredArticle.category === 'ai' ? 'bg-accent-teal/20 text-accent-teal' : featuredArticle.category === 'sports' ? 'bg-accent-coral/20 text-accent-coral' : featuredArticle.category === 'urban' ? 'bg-accent-slate/20 text-accent-slate' : 'bg-accent-ochre/20 text-accent-ochre'}`} data-id="element-548">
                    {categories.find(c => c.id === featuredArticle.category)?.label}
                  </span>
                </div>
                <h3 className="text-2xl lg:text-3xl font-semibold mb-4" data-id="element-549">
                  {featuredArticle.title}
                </h3>
                <p className="text-neutral-dark/80 mb-6 text-lg" data-id="element-550">
                  {featuredArticle.excerpt}
                </p>
              </div>
              <div className="flex items-center justify-between flex-wrap gap-y-3" data-id="element-551">
                <div className="flex items-center" data-id="element-552">
                  <div className="w-8 h-8 rounded-full bg-toronto-blue/20 flex items-center justify-center mr-2" data-id="element-553">
                    <UserIcon size={16} className="text-toronto-blue" data-id="element-554" />
                  </div>
                  <span className="text-sm" data-id="element-555">{featuredArticle.author}</span>
                  <span className="mx-2 text-neutral-dark/30" data-id="element-556">|</span>
                  <CalendarIcon size={14} className="text-neutral-dark/70 mr-1" data-id="element-557" />
                  <span className="text-sm" data-id="element-558">{featuredArticle.date}</span>
                  <span className="mx-2 text-neutral-dark/30" data-id="element-559">|</span>
                  <ClockIcon size={14} className="text-neutral-dark/70 mr-1" data-id="element-560" />
                  <span className="text-sm" data-id="element-561">{featuredArticle.readTime}</span>
                </div>
                <button className="text-toronto-blue font-medium hover:underline" data-id="element-562">
                  Read Article
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      {/* Search and Filter */}
      <section className="py-8 bg-white border-b" data-id="element-563">
        <div className="container mx-auto px-4 md:px-6" data-id="element-564">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-565">
            <div className="relative max-w-md w-full" data-id="element-566">
              <input type="text" placeholder="Search insights..." className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-toronto-blue/30" data-id="element-567" />
              <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-neutral-dark/50" data-id="element-568" />
            </div>
            <div className="flex items-center overflow-x-auto pb-2 md:pb-0 gap-2" data-id="element-569">
              <FilterIcon size={18} className="text-neutral-dark/70 mr-1" data-id="element-570" />
              <span className="text-sm font-medium mr-2" data-id="element-571">Filter:</span>
              {categories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.id)} className={`px-3 py-1 text-sm rounded-full whitespace-nowrap ${activeCategory === category.id ? 'bg-toronto-blue text-white' : 'bg-neutral-light text-neutral-dark hover:bg-neutral-light/70'}`} data-id="element-572">
                  {category.label}
                </button>)}
            </div>
          </div>
        </div>
      </section>
      {/* Articles Grid */}
      <section className="py-16 bg-white" data-id="element-573">
        <div className="container mx-auto px-4 md:px-6" data-id="element-574">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-575">
            {filteredArticles.slice(1).map((article, index) => <motion.div key={article.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-white border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow" data-id="element-576">
                <div className="h-48 overflow-hidden" data-id="element-577">
                  <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-578" />
                </div>
                <div className="p-6" data-id="element-579">
                  <div className="flex items-center mb-3" data-id="element-580">
                    <span className={`text-xs font-medium px-2 py-1 rounded-full ${article.category === 'ai' ? 'bg-accent-teal/20 text-accent-teal' : article.category === 'sports' ? 'bg-accent-coral/20 text-accent-coral' : article.category === 'urban' ? 'bg-accent-slate/20 text-accent-slate' : 'bg-accent-ochre/20 text-accent-ochre'}`} data-id="element-581">
                      {categories.find(c => c.id === article.category)?.label}
                    </span>
                  </div>
                  <h3 className="text-xl font-semibold mb-3" data-id="element-582">
                    {article.title}
                  </h3>
                  <p className="text-neutral-dark/80 mb-4 line-clamp-3" data-id="element-583">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between flex-wrap gap-y-2" data-id="element-584">
                    <div className="flex items-center text-sm text-neutral-dark/70" data-id="element-585">
                      <CalendarIcon size={14} className="mr-1" data-id="element-586" />
                      <span data-id="element-587">{article.date}</span>
                      <span className="mx-2 text-neutral-dark/30" data-id="element-588">|</span>
                      <ClockIcon size={14} className="mr-1" data-id="element-589" />
                      <span data-id="element-590">{article.readTime}</span>
                    </div>
                    <button className="text-toronto-blue hover:underline text-sm font-medium" data-id="element-591">
                      Read More
                    </button>
                  </div>
                </div>
              </motion.div>)}
          </div>
          {filteredArticles.length <= 1 && <div className="text-center py-12" data-id="element-592">
              <p className="text-lg text-neutral-dark/70" data-id="element-593">
                No articles found matching your filter.
              </p>
              <button onClick={() => setActiveCategory('all')} className="mt-4 text-toronto-blue hover:underline" data-id="element-594">
                Clear filters
              </button>
            </div>}
          <div className="mt-12 text-center" data-id="element-595">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-transparent border-2 border-toronto-blue text-toronto-blue hover:bg-toronto-blue/10 font-medium px-6 py-3 rounded transition-colors" data-id="element-596">
              Load More Articles
            </motion.button>
          </div>
        </div>
      </section>
      {/* Newsletter Section */}
      <section className="py-16 bg-toronto-blue text-white" data-id="element-597">
        <div className="container mx-auto px-4 md:px-6" data-id="element-598">
          <div className="max-w-3xl mx-auto text-center" data-id="element-599">
            <h2 className="text-3xl font-display font-bold mb-6" data-id="element-600">
              Stay Updated with Our Latest Insights
            </h2>
            <p className="text-lg mb-8 opacity-90" data-id="element-601">
              Subscribe to our newsletter to receive the latest research trends,
              industry insights, and thought leadership directly to your inbox.
            </p>
            <div className="max-w-md mx-auto" data-id="element-602">
              <form className="flex" data-id="element-603">
                <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded-l text-neutral-dark focus:outline-none" data-id="element-604" />
                <motion.button whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="bg-canada-red text-white px-6 py-3 rounded-r font-medium hover:bg-canada-red/90 transition-colors" data-id="element-605">
                  Subscribe
                </motion.button>
              </form>
              <p className="text-sm mt-3 opacity-80" data-id="element-606">
                We respect your privacy. You can unsubscribe at any time.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Insights;